const isOpenBodyClass = 'react-overlay-sidebar-is-open';

window.__restore_window_scroll = false;

const isOpenOverlaySidebar = () => {
	return document.body.classList.contains(isOpenBodyClass);
};

let isOn = false;
// let scrollbarSize;
let scrollTop;

// function getScrollbarSize () {
// 	if (typeof scrollbarSize !== 'undefined') return scrollbarSize;
//
// 	const doc = document.documentElement;
// 	const dummyScroller = document.createElement('div');
// 	dummyScroller.setAttribute('style', 'width:99px;height:99px;position:absolute;top:-9999px;overflow:scroll;');
// 	doc.appendChild(dummyScroller);
// 	scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
// 	doc.removeChild(dummyScroller);
// 	return scrollbarSize;
// }
//
function hasScrollbar() {
	return document.documentElement.scrollHeight > document.documentElement.clientHeight;
}

function on() {
	if (isOn) return;
	const doc = document.documentElement;

	if (hasScrollbar()) {
		doc.style.overflowY = 'scroll';
		doc.style.overflowX = 'auto';
	}

	scrollTop = window.pageYOffset;
	doc.style.width = '100%';
	doc.style.position = 'fixed';
	doc.style.top = `${-scrollTop}px`;
	isOn = true;
	window.__restore_window_scroll = true;
}

function off() {
	if (!isOn || isOpenOverlaySidebar()) return;
	const doc = document.documentElement;
	doc.style.width = '';
	doc.style.position = '';
	doc.style.top = '';
	doc.style.overflowY = '';
	doc.style.overflowX = '';

	if (window.__restore_window_scroll) {
		window.scroll(0, scrollTop);
	}

	isOn = false;
	window.__restore_window_scroll = false;
}

function fullOff() {
	if (!isOn) return;
	const doc = document.documentElement;
	doc.style.width = '';
	doc.style.position = '';
	doc.style.top = '';
	doc.style.overflowY = '';
	doc.style.overflowX = '';
	window.scroll(0, scrollTop);
	isOn = false;
	window.__restore_window_scroll = false;
}

function toggle() {
	if (isOn) {
		off();
		return;
	}
	on();
}

const noScroll = {
	on,
	off,
	toggle,
	fullOff,
	get isOn() {
		return isOn;
	},
};

module.exports = noScroll;
